<template>
  <div id="consultarldiwrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Licitações, Dispensas e Inexigibilidades" :botoes="botoesHeader" breakpoint="xl" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form @submit.prevent="filtrarLDIs" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-numero" label-size="md" label="Número">
                  <b-form-input v-model="filtros.numero"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-ano" label-size="md" label="Ano">
                  <b-form-input v-model="filtros.ano"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-modalidade" label-size="md" label="Modalidade"
                  label-for="input-filtroNaturezaAjuste" label-class="text-left">
                  <b-form-select v-model="filtros.idModalidade" id="select-filtros-modalidade"
                    :options="modalidadeLicitacao">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-objeto" label-size="md" label="Objeto">
                  <b-form-input v-model="filtros.objeto"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-situacao" label-size="md" label="Situação">
                  <b-form-select id="select-filtros-situacao" v-model="filtros.idSituacao" :options="situacaoLicitacao">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="submit" :disabled="tableBusy">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
          sort-by="" :sort-desc="true" striped stacked="xl" show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-sm-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="detalhesLicitacao(row.item.IdLicitacao)">
                <font-awesome-icon icon="eye" />
                <span>Detalhes</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="row.item.PodeEditar" @click="editarLicitacao(row.item)">
                <font-awesome-icon icon="edit" />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="row.item.PodeCancelar" @click="row.toggleDetails">
                <font-awesome-icon icon="trash" />
                <span>Cancelamento</span>
              </b-dropdown-item>
              <b-dropdown-item @click="detalhesLicitacao(row.item.IdLicitacao, true)">
                <font-awesome-icon icon="trash" />
                <span>Excluir</span>
              </b-dropdown-item>
            </b-dropdown>
            <div class="actions-icons lgvert d-none d-sm-flex">
              <b-link class="text-dark" @click="detalhesLicitacao(row.item.IdLicitacao)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link v-if="row.item.PodeEditar" class="text-dark" @click="editarLicitacao(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link v-if="row.item.PodeCancelar" class="text-dark" @click="row.toggleDetails">
                <font-awesome-icon icon="ban" />
                <div style="font-size: 12px">Cancelamento</div>
              </b-link>
              <b-link class="text-dark" @click="detalhesLicitacao(row.item.IdLicitacao, true)">
                <font-awesome-icon icon="trash" />
                <div style="font-size: 12px">Excluir</div>
              </b-link>
            </div>
          </template>
          <template #row-details="row">
            <opcoes-cancelamento-licitacao :licitacao="row.item" @recolher="row.toggleDetails"
              @refresh="atualizarLista(row)" />
          </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
      </b-card-body>
    </b-card>
    <modal-importar-licitacao v-if="exibirModalImportacao" @fecharModal="toggleModalImportacao"
      @atualizarLicitacoes="loadData" />
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import OpcoesCancelamentoLicitacao from '@/components/licitacoes/ldi/editar-ldi/OpcoesCancelamentoLicitacao.vue';
import ModalImportarLicitacao from '@/components/licitacoes/ldi/modais/ModalImportarLicitacao.vue';
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import ldiService from '@/services/licitacoes/ldiService';
import { store } from "@/store";
import { BotaoSagres } from '@/types/botao-sagres';
import { fieldsLicitacoesConsulta } from '@/types/licitacoes/ldi/fields-licitacoes';
import { FiltrosLicitacoes } from '@/types/licitacoes/ldi/filtros-licitacoes';
import { LicitacaoResumida } from '@/types/licitacoes/ldi/licitacao-resumida';
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';

const CompProps = Vue.extend({
  name: 'ConsultarLDI',
  components: { CardFiltrosBusca, HeaderSagres, ModalImportarLicitacao, OpcoesCancelamentoLicitacao, TablePagination }
})

@Component
export default class ConsultarLDI extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsLicitacoesConsulta
  items: LicitacaoResumida[] = []
  filtros: FiltrosLicitacoes = new FiltrosLicitacoes()

  situacaoLicitacao: any[] = []
  modalidadeLicitacao: any[] = []

  currentPage = 1
  pageSize = 10
  totalRows = 0

  tableBusy = false
  exibirModalImportacao = false
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'handshake',
      texto: 'Nova Licitação',
      url: '/modulo-licitacoes/ldi/editarLicitacao',
    },
    {
      id: 2,
      icone: 'fighter-jet',
      texto: 'Nova Dispensa/Inexigibilidade',
      url: '/modulo-licitacoes/ldi/editarDispensaInex'
    },
    {
      id: 3,
      icone: 'laptop',
      texto: 'Nova Dispensa Eletrônica',
      url: '/modulo-licitacoes/ldi/editarDispensaEletronica'
    },
    {
      id: 4,
      icone: 'file-upload',
      texto: 'Enviar Arquivo',
      acao: this.toggleModalImportacao
    }
  ]

  async mounted() {
    try {
      store.blockScreen = true
      const responseSituacao = await ldiService.listarSituacoes()
      this.situacaoLicitacao = [{ value: null, text: 'TODOS' }, ...responseSituacao.data.map(t => ({ value: t.Id, text: t.Descricao }))]
      const responseModalidade = await ldiService.listarModalidades('')
      this.modalidadeLicitacao = [{ value: null, text: 'TODOS' }, ...responseModalidade.data.map(t => ({ value: t.IdModalidade, text: t.DeModalidade }))]

      await this.loadData()

    }
    catch (e) {
      console.error(e)
    }
    finally {
      store.blockScreen = false
    }

  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async pageChange(value) {
    this.currentPage = value;
    await this.loadData();
  }

  async loadData(): Promise<void> {
    try {
      this.tableBusy = true

      let response: any = null;
      response = await ldiService.filtrarLicitacoes(
        this.currentPage,
        this.pageSize,
        this.filtros
      );

      if (response) {
        this.totalRows = response.totalRows;

        this.items = response.licitacoesResumidas.map(function (p: any) {
          const retorno = Object.assign(new LicitacaoResumida(), p)
          retorno.tratarDadosDaAPI()
          return retorno
        })
      } else {
        this.$toast.error("Erro ao obter a lista de licitações");
      }
    } finally {
      this.tableBusy = false;
    }
  }

  async detalhesLicitacao(IdLicitacao: number, excluir = false) {
    this.$router.push('/modulo-licitacoes/ldi/detalhes/' + IdLicitacao + (excluir ? '?excluir' : ''))
  }
  async editarLicitacao(item: LicitacaoResumida) {
    if (item.Modalidade === 'DISPENSA' || item.Modalidade === 'INEXIGIBILIDADE')
      this.$router.push('/modulo-licitacoes/ldi/editarDispensaInex/' + item.IdLicitacao)
    else if(item.Modalidade === 'DISPENSA ELETRÔNICA')
      this.$router.push('/modulo-licitacoes/ldi/editarDispensaEletronica/' + item.IdLicitacao)
    else
      this.$router.push('/modulo-licitacoes/ldi/editarLicitacao/' + item.IdLicitacao)
  }

  /**
   * chamado quando uma LDI é anulada, colapsa os detalhes e refaz a paginação.
   * @since 20230824
   */
  atualizarLista(row: any): void {
    row.toggleDetails()
    this.loadData()
  }

  async limparFiltros() {
    //console.log('call limparFiltros')
    this.filtros.limpar();
  }
  async filtrarLDIs() {
    this.pageChange(1);
  }
  toggleModalImportacao() {
    this.exibirModalImportacao = !this.exibirModalImportacao
  }
  /*  não parece estar funcionando, então vamos trocar este evento por um loadData
   async atualizarLicitacoes(licitacoes: LicitacaoResumida[]) {
      const idsPresentesAqui = this.items.map(t => t.IdLicitacao)
      let houveAtualizacao = false
      for await (const lic of licitacoes) {
        if (idsPresentesAqui.includes(lic.IdLicitacao)) {
          const index = this.items.findIndex(t => t.IdLicitacao === lic.IdLicitacao)
          this.items.splice(index, 1, lic)
          houveAtualizacao = true
        }
      }
      if (houveAtualizacao) this.$emit('input', this.items);
    } */
};
</script>

<style scoped></style>